const FormExtra = ({ onRememberMeChange }) => {
	return (
		<div className="mb-2 grid grid-cols-1 gap-4 place-items-center md:grid-cols-2 md:mb-6">
			<div className="flex items-center mr-2">
				<input
					id="remember-me"
					name="remember-me"
					type="checkbox"
					className="h-4 w-4 text-primary focus:ring-primary/70 border-gray-300 rounded"
					onChange={onRememberMeChange}
				/>
				<label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
					Se souvenir de moi
				</label>
			</div>

			<div className="text-sm">
				<a href="/reset-password" className="transition duration-300 font-medium text-primary hover:primary/80 p-4">
					Mot de passe oublié?
				</a>
			</div>
		</div>
	);
};

export default FormExtra;
